export default {
  getTroncos: state => state.troncos,
  getTroncoSelecionado: state => state.troncoSelecionado,
  getTroncoUse: state => state.troncoUse,
  getRotasDisponiveis: state => state.rotasDisponiveis,
  getGruposDeRotas: state => state.gruposDeRotas
}
